import React, { useCallback, useMemo } from "react";
import CrudForm from "../shared/crud/form";
import schema from "./domain/behaviour.schema.json";
import { useIntl } from "react-intl";
import actions from "../../lib/actions";
import { withAuthorizationVerifier } from "../../components/authorization-verifier";
import { useProperty } from "../../components/property-provider";
import { useHttpClient } from "../../lib/http";
import { BehaviourEntity } from "./domain/behaviour.entity";
import { getBehaviour, updateBehaviour } from "./infrastructure/behaviour.api";
import { IConfig, useConfig } from "../../lib/config";
import { regenPropertyCache } from "../common/api";
import styled from "styled-components";
import { messages } from "./messages";
import { buildFormConfiguration } from "./domain/behaviour.formConfiguration";
import { useUserAuthInfo } from "../../lib/auth";

export const FormContainer = styled("div")`
  .form-group.field.field-boolean {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    justify-content: flex-end;
  }

  select {
    width: 280px;
  }

  input[type="text"] {
    width: 280px;
  }
`;

function BehaviourForm({ propertyTicker }: { propertyTicker: string }) {
  const intl = useIntl();
  const propertyInfo = useProperty();
  const configuration: IConfig = useConfig();
  const middlewareClient = useHttpClient(configuration.middlewareEndpoint);
  const apiClient = useHttpClient(configuration.secureApiEndpoint);
  const userAuthInfo = useUserAuthInfo();

  const handleGetOne = useCallback(async () => {
    return await getBehaviour(middlewareClient, propertyInfo.ticker);
  }, [middlewareClient, propertyInfo.ticker]);

  const handleUpdate: (entity: BehaviourEntity) => Promise<void> = useCallback(
    async entity => {
      await updateBehaviour(propertyInfo.ticker, entity, middlewareClient);
      await regenPropertyCache(apiClient, propertyInfo.ticker);
      alert(intl.formatMessage(messages.saveSuccess));
      return;
    },
    [apiClient, intl, middlewareClient, propertyInfo.ticker]
  );
  const formConfiguration = useMemo(() => buildFormConfiguration(), []);
  if (!userAuthInfo?.isWitAdmin) {
    // @ts-ignore
    delete schema.properties.taxesRateType;
  }

  return (
    <CrudForm<BehaviourEntity>
      id={"behaviourEntity"}
      schema={schema}
      formConfiguration={formConfiguration}
      messages={messages}
      onGet={handleGetOne}
      onUpdate={handleUpdate}
      canUpdate={actions.ModifyAppeareanceSettings}
      enumsOptional
      container={FormContainer}
    />
  );
}

export default withAuthorizationVerifier(BehaviourForm);
